import sortBy from 'lodash/sortBy';

// Types
import { IDropdownType } from 'components/Dropdown/Dropdown';

// Sort all of the countries alphabetically.
export const sortStates = (states: IDropdownType[]): IDropdownType[] => sortBy(states, 'Title');
